/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { useMemo } from 'react';
import { hooks, unstable } from '@broadleaf/admin-components';

const { useTracking } = hooks;
const { ContextRequest } = unstable;

const { ContextParameters } = ContextRequest;

/**
 * @typedef {Object} ConnectContextParams
 * @property {Object} [tracking] - tracking parameters
 * @property {string} [id] - alias for {@code propertyId}
 * @property {string} [propertyId] - the the account ID System Property's ID
 * @property {SystemProperty} [property] - the account ID System Property's data
 * @property {SystemProperty} [parent] - alias for {@code property}
 */

/**
 *
 * @param {Object} metadata - the view metadata
 * @param {String} [accountId] - the current account ID
 *
 * @returns {ConnectContextParams} The context params
 */
export default function useContextParams(metadata, accountId) {
  const tracking = useTracking(metadata);

  return useMemo(() => {
    const contextParams = {};

    if (tracking) {
      contextParams[ContextParameters.TRACKING] = tracking;
    }

    if (!!accountId) {
      contextParams.parent = contextParams.property = { value: accountId };
      contextParams.id = contextParams.accountId = accountId;
    }

    return contextParams;
  }, [accountId, tracking]);
}
